import { render, staticRenderFns } from "./DispatchNote.vue?vue&type=template&id=1d2f42cc&"
import script from "./DispatchNote.vue?vue&type=script&lang=js&"
export * from "./DispatchNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports